'use client';
import { notFound, useParams } from 'next/navigation';
import { Suspense } from 'react';
import { Breadcrumbs } from '~/components/Breadcrumbs';
import { Card } from '~/components/Card';
import { Divider } from '~/components/Divider';
import { Leg } from '~/components/Leg';
import { useJourneyGuide } from '~/contexts/JourneyGuideContext';
import TimelineTransformer, { type LegTimelineItem } from '~/transformers/Dato/TimelineTransformer';

export default function TicketDetail() {
  const params = useParams<{ legId: string; tripId: string }>();
  const tripId = params?.tripId;
  const legId = params?.legId;

  const [journeyGuide] = useJourneyGuide();
  const { timelineItems: items } = new TimelineTransformer(journeyGuide.itinerary?.items ?? []).transform();

  const leg = items.find((item) => item.id === legId) as LegTimelineItem;
  if (!leg) {
    return notFound();
  }

  return (
    <div className="relative mb-48px">
      <div className="px-4 pt-4 bg-primary-100">
        <Breadcrumbs
          items={[
            {
              href: `/journey-guide/${tripId}#${legId}`,
              label: 'Journey Guide'
            },
            {
              label: `${leg.origin} to ${leg.destination}`,
              isCurrent: true,
              href: '#'
            }
          ]}
        />
      </div>
      <Divider variant="horizontal" />
      <Card spaceHorizontal="--by-space-400" spaceVertical="--by-space-300">
        <Suspense>
          <Leg leg={leg} isDetailed showTickets />
        </Suspense>
      </Card>
    </div>
  );
}
